module.exports = __webpack_public_path__ + "media/images/main_events/2024/thu-2024-ticket-mask-377a9cb59f71a2b9b24b0fc8ac33b50d.svg";